import { Button } from '@get-mosh/msh-shared';
import Heading from '../Heading/Heading';
import common from 'src/data/common.json';
import Routes from 'src/constants/Routes';

export interface FreeConsultProps {
    title?: string;
    cta?: {
        text: string;
        href: string;
        location?: string;
    };
}

const FreeConsult = ({
    title = 'Invest in your health, reap the benefits',
    cta = {
        text: common.startMyFreeConsult,
        href: Routes.SEX_INITIAL_QUIZ,
    },
}: FreeConsultProps) => {
    return (
        <div className="container text-center">
            {title && (
                <Heading level="h2" className="mb-4">
                    {title}
                </Heading>
            )}
            {cta && <Button {...cta} as="a" stretch />}
        </div>
    );
};

export default FreeConsult;
